export default __webpack_public_path__ + "static/media/ivygourd.fb693600.png";